import { axios } from '~/common/utils/request'
const frontPath = 'rest/store/logistics/v3/'
const adminPath = 'rest/erp/logistics/v3/'

// 发货单列表
export const getFrontShippingList = params => axios({
  url: `${frontPath}shipping/order/list`,
  method: 'post',
  data: params
})

// 发货单详情
export const getFrontShippingDetail = id => axios({
  url: `${frontPath}shipping/order/detail/${id}`,
  method: 'get'
})

// 发货单审批(通过/退回)
export const approveFrontShipping = params => axios({
  url: `${adminPath}shipping/order/approved`,
  method: 'post',
  data: params
})

// 发货项列表
export const getFrontShippingLineList = params => axios({
  url: `${frontPath}shipping/line/list`,
  method: 'post',
  data: params
})
